import { ISapSupplierPayloadItem } from "../../../types"

export interface ISupplierEditDraft {
  recordId: string
  payload: ISapSupplierPayloadItem[]
  savedAt: string
  baseUpdatedAt: string | null
}

const DRAFT_STORAGE_PREFIX = "sapspl-edit-draft:"

const getDraftKey = (recordId: string): string => `${DRAFT_STORAGE_PREFIX}${recordId}`

export const getSupplierEditDraft = (recordId: string): ISupplierEditDraft | null => {
  try {
    const rawDraft = window.localStorage.getItem(getDraftKey(recordId))
    if (!rawDraft) return null

    const parsedDraft = JSON.parse(rawDraft) as ISupplierEditDraft
    if (!parsedDraft || parsedDraft.recordId !== recordId || !Array.isArray(parsedDraft.payload)) {
      window.localStorage.removeItem(getDraftKey(recordId))
      return null
    }

    return parsedDraft
  } catch (_error) {
    window.localStorage.removeItem(getDraftKey(recordId))
    return null
  }
}

export const saveSupplierEditDraft = (draft: ISupplierEditDraft): void => {
  window.localStorage.setItem(getDraftKey(draft.recordId), JSON.stringify(draft))
}

export const removeSupplierEditDraft = (recordId: string): void => {
  window.localStorage.removeItem(getDraftKey(recordId))
}
